export const WORK_FLOW_OPTIONS = ['None', 'Tags', 'Sub Project', 'User'];

export const INSPECTION_WORK_FLOW_OPTIONS = [
  'None',
  'Checklist',
  'Tags',
  'Sub Project',
  'User',
];
